/* ============================================================
   KAIRII — Collection filter + deep-link engine
   Extracted from sections/kairii-collection.liquid (was a ~245-line inline <script>).
   Localized/catalogue data is injected by the section as a JSON tag (#kr-collection-data);
   everything else is DOM-driven via data-kr-* hooks. Powers: rail facets, sort,
   in-catalog search, ?series/?curate/?q deep-links, dynamic header/breadcrumb/chips,
   and the live count. Behaviour is unchanged from the former inline version.
   ============================================================ */
(function () {
  'use strict';
  var root = document.querySelector('[data-kr-collection]');
  if (!root) return;
  // Localized strings + series slug→name map, rendered by the section.
  var I;
  try { I = JSON.parse(document.getElementById('kr-collection-data').textContent); }
  catch (e) { return; }
  I.seriesNames = I.seriesNames || {};

  var cards = [].slice.call(root.querySelectorAll('.kr-card'));
  var facets = [].slice.call(root.querySelectorAll('.kr-facet input'));
  var sortSel = root.querySelector('[data-kr-sort]');
  var countEl = root.querySelector('[data-kr-count]');
  var bigEl = root.querySelector('[data-kr-report-big]');
  var grid = root.querySelector('[data-kr-grid]');
  var empty = root.querySelector('[data-kr-empty]');
  var emptyTitleEl = root.querySelector('[data-kr-empty-title]');
  var toggle = root.querySelector('[data-kr-filters-toggle]');
  var filters = root.querySelector('[data-kr-filters]');
  var headingEl = root.querySelector('[data-kr-heading]');
  var sublineEl = root.querySelector('[data-kr-subline]');
  var breadcrumbEl = root.querySelector('[data-kr-breadcrumb]');
  var chipWrap = root.querySelector('[data-kr-chips]');

  // --- deep-link state (mega-menu / search overlay) ---
  var curate = null;     // grail | new | pre | exclusive
  var query = '';        // free-text search within the catalog
  var seriesDeep = [];   // series slugs from ?series= that have no rail facet

  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function slugify(s) { return String(s).toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, ''); }
  function statusWords(st) {
    if (st === 'in')   return 'in stock available auf lager sofort';
    if (st === 'low')  return 'low stock niedriger bestand';
    if (st === 'pre')  return 'pre-order preorder vorbestellung reserve reservieren';
    if (st === 'sold') return 'sold out ausverkauft';
    return '';
  }
  function setOf(group) {
    var s = {}, any = false;
    facets.forEach(function (f) { if (f.getAttribute('data-filter') === group && f.checked) { s[f.value] = 1; any = true; } });
    return any ? s : null;
  }
  function anyChecked(group) { return facets.some(function (f) { return f.getAttribute('data-filter') === group && f.checked; }); }
  // effective series filter (slugs): checked rail facets ∪ deep-linked slugs. null = no constraint.
  function seriesSet() {
    var set = {};
    facets.forEach(function (f) { if (f.getAttribute('data-filter') === 'series' && f.checked) set[slugify(f.value)] = 1; });
    seriesDeep.forEach(function (sl) { set[sl] = 1; });
    return Object.keys(set).length ? set : null;
  }

  // per-card search haystack (built once)
  cards.forEach(function (c) {
    var nameEl = c.querySelector('.kr-card__name');
    c.__hay = [
      c.getAttribute('data-series') || '',
      c.getAttribute('data-line') || '',
      nameEl ? nameEl.textContent : '',
      statusWords(c.getAttribute('data-status')),
      c.getAttribute('data-grail') === '1' ? 'grail' : '',
      c.getAttribute('data-new') === '1' ? 'new neu arrival neuheit' : '',
      c.getAttribute('data-excl') === '1' ? 'sdcc exclusive exklusiv' : ''
    ].join(' ').toLowerCase();
  });

  function matchCurate(c) {
    if (!curate) return true;
    if (curate === 'grail') return c.getAttribute('data-grail') === '1';
    if (curate === 'new') return c.getAttribute('data-new') === '1';
    if (curate === 'pre') return c.getAttribute('data-status') === 'pre';
    if (curate === 'exclusive') return c.getAttribute('data-excl') === '1';
    return true;
  }
  function matchQuery(c) {
    if (!query) return true;
    return query.toLowerCase().split(/\s+/).filter(Boolean).every(function (t) { return c.__hay.indexOf(t) !== -1; });
  }

  function renderCrumb(deep, crumbText) {
    if (!breadcrumbEl) return;
    var html = '<a href="' + esc(I.homeUrl) + '">' + esc(I.homeLabel) + '</a><span class="kr-sep">/</span>';
    if (deep) {
      html += '<a href="#" data-kr-crumb-reset>' + esc(I.crumbCollection) + '</a><span class="kr-sep">/</span><span data-kr-crumb>' + esc(crumbText) + '</span>';
    } else {
      html += '<span data-kr-crumb>' + esc(crumbText) + '</span>';
    }
    breadcrumbEl.innerHTML = html;
    var rl = breadcrumbEl.querySelector('[data-kr-crumb-reset]');
    if (rl) rl.addEventListener('click', function (e) { e.preventDefault(); resetAll(); });
  }

  function renderHeader(n) {
    var sset = seriesSet();
    var sKeys = sset ? Object.keys(sset) : [];
    var heading, subline, crumb, deep = false;
    if (query) {
      heading = '“' + query + '”';
      subline = (n === 1 ? I.sublineSearchOne : I.sublineSearchOther).replace('%n', n);
      crumb = heading; deep = true;
    } else if (curate) {
      heading = I.buckets[curate] || I.titleDefault;
      subline = I.sublineCurate.replace('%s', heading);
      crumb = heading; deep = true;
    } else if (sKeys.length === 1 && !anyChecked('line') && !anyChecked('avail')) {
      var nm = I.seriesNames[sKeys[0]] || sKeys[0];
      heading = nm; subline = I.sublineSeries.replace('%s', nm); crumb = nm; deep = true;
    } else {
      heading = I.titleDefault; subline = I.sublineDefault; crumb = I.titleDefault; deep = false;
    }
    if (headingEl) headingEl.textContent = heading;
    if (sublineEl) sublineEl.textContent = subline;
    renderCrumb(deep, crumb);
  }

  function makeChip(kind, label) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'kr-chip kr-chip--active';
    b.setAttribute('data-kr-chip', kind);
    b.setAttribute('aria-label', I.chipRemove + ': ' + label);
    var s = document.createElement('span');
    s.textContent = label;
    b.appendChild(s);
    b.insertAdjacentHTML('beforeend', '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg>');
    b.addEventListener('click', function () {
      if (kind === 'query') query = '';
      else if (kind === 'curate') curate = null;
      apply();
    });
    return b;
  }
  function renderChips() {
    if (!chipWrap) return;
    chipWrap.innerHTML = '';
    if (query) chipWrap.appendChild(makeChip('query', '“' + query + '”'));
    if (curate) chipWrap.appendChild(makeChip('curate', I.buckets[curate] || curate));
  }

  function syncURL() {
    try {
      var params = new URLSearchParams(window.location.search);
      params.delete('series'); params.delete('curate'); params.delete('q');
      var set = seriesSet();
      if (set) params.set('series', Object.keys(set).join(','));
      if (curate) params.set('curate', curate);
      if (query) params.set('q', query);
      var qs = params.toString();
      window.history.replaceState(null, '', window.location.pathname + (qs ? '?' + qs : '') + window.location.hash);
    } catch (e) {}
  }

  function apply() {
    var series = seriesSet(), line = setOf('line'), avail = setOf('avail');
    var visible = [];
    cards.forEach(function (c) {
      var ok = (!series || series[slugify(c.getAttribute('data-series'))])
            && (!line   || line[c.getAttribute('data-line')])
            && (!avail  || avail[c.getAttribute('data-status')])
            && matchCurate(c) && matchQuery(c);
      c.classList.toggle('is-hidden', !ok);
      if (ok) visible.push(c);
    });

    var mode = sortSel ? sortSel.value : 'featured';
    if (mode === 'low' || mode === 'high') {
      visible.sort(function (a, b) {
        var d = (parseInt(a.getAttribute('data-price'), 10) || 0) - (parseInt(b.getAttribute('data-price'), 10) || 0);
        return mode === 'low' ? d : -d;
      });
      visible.forEach(function (c) { grid.insertBefore(c, empty); });
    } else {
      cards.forEach(function (c) { grid.insertBefore(c, empty); }); // original catalog order
    }

    var n = visible.length;
    if (countEl) countEl.textContent = pad(n) + ' ' + (countEl.getAttribute('data-label') || '');
    if (bigEl) bigEl.textContent = n;
    if (empty) empty.hidden = n > 0;
    if (emptyTitleEl) emptyTitleEl.textContent = query ? I.emptyQuery.replace('%s', query) : I.emptyDefault;

    renderHeader(n);
    renderChips();
    syncURL();
  }

  function resetAll() {
    facets.forEach(function (f) { f.checked = false; });
    curate = null; query = ''; seriesDeep = [];
    if (sortSel) sortSel.value = 'featured';
    apply();
  }

  facets.forEach(function (f) { f.addEventListener('change', apply); });
  if (sortSel) sortSel.addEventListener('change', apply);
  if (toggle && filters) toggle.addEventListener('click', function () {
    var o = filters.classList.toggle('open'); toggle.setAttribute('aria-expanded', o ? 'true' : 'false');
  });
  var resetBtn = root.querySelector('[data-kr-reset]');
  if (resetBtn) resetBtn.addEventListener('click', resetAll);

  // --- read deep-links on load (?series=…&curate=…&q=…) ---
  try {
    var p = new URLSearchParams(window.location.search);
    var qp = p.get('q'); if (qp) query = qp.trim();
    var cp = p.get('curate'); if (cp && I.buckets[cp]) curate = cp;
    var sp = p.get('series');
    if (sp) {
      sp.split(',').forEach(function (x) {
        var slug = slugify(decodeURIComponent(x));
        if (!slug) return;
        // prefer the matching rail facet; else keep as an orphan deep-link slug
        var f = facets.filter(function (ff) { return ff.getAttribute('data-filter') === 'series' && slugify(ff.value) === slug; })[0];
        if (f) f.checked = true;
        else if (seriesDeep.indexOf(slug) === -1) seriesDeep.push(slug);
      });
    }
  } catch (e) {}

  apply();
})();
